document.addEventListener("DOMContentLoaded", () => {
    
    let filterSwipers = document.querySelectorAll(".filter-swiper-js");
    let prevArrow = document.querySelectorAll('.filter-swiper-button-prev');
	let nextArrow = document.querySelectorAll('.filter-swiper-button-next');
	let pagination = document.querySelectorAll('.filter-swiper-pagination');

    if (!filterSwipers) return;

    // loop through each carousel
    filterSwipers.forEach((slider, index)=>{

        // set variables
        let autoplayJS = false;

        // get custom attributes set by the block
        const slidesToShow = slider.getAttribute('data-slides-to-show');
        const slidesToScroll = slider.getAttribute('data-slides-to-scroll');
        const grid = slider.getAttribute('data-grid') ? true : false;
        const loop = slider.getAttribute('data-loop') ? true : false;
        const autoPlay = slider.getAttribute('data-auto-play') ? true : false;
        const autoPlaySpeed = slider.getAttribute('data-auto-play-speed');
        const spaceBetween = slider.getAttribute('data-space-between');
        const showDots = slider.getAttribute('data-show-dots') ? true : false;
        const showArrows = slider.getAttribute('data-show-arrows') ? true : false;
        const mobileCarouselBreakpoint = slider.getAttribute('data-mobile-carousel-breakpoint');;
        const mobileSlidesToShow = slider.getAttribute('data-mobile-slides-to-show');
        const mobileSlidesToScroll = slider.getAttribute('data-mobile-slides-to-scroll');
        const mobileSpaceBetween = slider.getAttribute('data-mobile-space-between');
        const tabletCarouselBreakpoint = slider.getAttribute('data-tablet-carousel-breakpoint');;
        const tabletSlidesToShow = slider.getAttribute('data-tablet-slides-to-show');
        const tabletSpaceBetween = slider.getAttribute('data-tablet-space-between');

        if (autoPlay) {
            autoplayJS = {
                delay: autoPlaySpeed,
                pauseOnMouseEnter: true,
            };
        }

        let responsiveOptions = '';
        let gridOptions = '';
        let defaultOptions = {
            speed: 500,
            slidesPerView: mobileSlidesToShow,
            spaceBetween: mobileSpaceBetween,
            grabCursor: true,
            loop: loop,
            centeredSlides: false,
            watchSlidesProgress: true,  //
            navigation: {
                enabled: showArrows,
                nextEl: nextArrow[index],
                prevEl: prevArrow[index],
            },
            pagination: {
                enabled: showDots,
                el: pagination[index],
                clickable: true,
            },
            autoplay: autoplayJS
        }

        if (grid) {
            gridOptions = {
                grid: {
                    rows: 2
                }
            };
        }

        if (slidesToShow != 1) {
            responsiveOptions = {
                breakpoints: {
                    [mobileCarouselBreakpoint]: {
                        slidesPerView: tabletSlidesToShow ,
                        spaceBetween: tabletSpaceBetween,
                      },
                      [tabletCarouselBreakpoint]: {
                        slidesPerView: slidesToShow ,
                        spaceBetween: spaceBetween,
                      },
                }
            }
        } else {
            responsiveOptions = {
                breakpoints: {
                    [mobileCarouselBreakpoint]: {
                        slidesPerView: slidesToShow,
                        spaceBetween: spaceBetween
                    }
                }
            }
        }

        const filterSwiper = new Swiper(slider, {
            ...defaultOptions,
            ...gridOptions,
            ...responsiveOptions
        });
    });
});